module.exports = __webpack_public_path__ + "static/media/fontello.33f014d4.eot";